import Cookies from "js-cookie";
import { find, map, findIndex, uniqBy } from "lodash";
import types from "./types";

export default {
  [types.UPDATE_DATE_RANGE]: (state, { start, end }) => {
    state.dateRange = {
      start,
      end
    };
  },
  [types.FETCH_PRODUCTS]: (state, payload) => {
    const { data, meta, link } = payload;
    state.meta = meta;
    state.products = data;
    state.link = link;
  },
  [types.FETCH_COLLECTION_PER_PAGE]: (state, payload) => {
    const { data, meta, link } = payload;
    state.meta = meta;
    state.collection = data;
    state.link = link;
  },
  [types.USER_ADD]: (state, payload) => {
    payload.new = true;
    state.activeUser = payload;
    if (find(state.users, { id: payload.id })) {
      state.users = map(state.users, user => {
        if (user.id === payload.id) {
          return payload;
        }
        return user;
      });
    } else {
      state.users = [payload, ...state.users];
    }
  },
  [types.USERS_ADD]: (state, payload) => {
    state.users = [...payload, ...state.users];
  },
  [types.USER_DELETE]: (state, payload) => {
    state.activeUser = null;
    const index = findIndex(state.users, { id: payload });
    state.users = state.users.filter(user => user.id !== payload);
    const length = state.users.length;

    if (length == 1) {
      state.activeUser = state.users[0];
    } else if (index < length) {
      state.activeUser = state.users[index];
    } else if (index >= length && length != 0) {
      state.activeUser = state.users[index - 1];
    }
  },
  [types.USER_EDIT]: (state, payload) => {
    state.activeUser = payload;

    state.users = map(state.users, user => {
      if (user.id === payload.id) {
        return payload;
      }
      return user;
    });
  },
  [types.USER_LIST_RESET]: state => {
    state.users = [];
    state.userMeta = {
      page: 1,
      hasNextPage: true,
      size: 40
    };
  },
  [types.USER_LIST_PAGINATE]: (state, payload) => {
    const { page, size } = state.userMeta;
    state.users = uniqBy([...state.users, ...payload.data], "id");
    state.userMeta.hasNextPage = payload.meta.hasNextPage;
    state.userMeta.size = 20;
    state.userMeta.page = page + 1;

    if (page == 1 && size == 40) {
      state.userMeta.page = page + 2;
    }
  },
  [types.USER_REMOVE_NEW_TAG]: (state, payload) => {
    state.users = state.users.map(user => {
      if (user.id === payload) {
        delete user.new;
      }
      return user;
    });
  },

  [types.GROUP_ADD]: (state, payload) => {
    state.groups = [payload, ...state.groups];
  },
  [types.GROUP_ADD_MEMBER]: (state, payload) => {
    state.groups = map(state.groups, group => {
      if (group.id === payload.groupId) {
        var newGroup = group;
        newGroup.Users = [...newGroup.Users, ...payload.users];
        return newGroup;
      }
      return group;
    });
  },
  [types.GROUP_DELETE]: (state, payload) => {
    state.groups = state.groups.filter(group => group.id !== payload);
  },
  [types.GROUP_DELETE_MEMBER]: (state, payload) => {
    state.groups = map(state.groups, group => {
      if (group.id === payload.groupId) {
        var users = group.Users;
        users = users.filter(user => user.id !== payload.userId);
        group.Users = users;
        return group;
      }
      return group;
    });
  },
  [types.GROUP_EDIT]: (state, payload) => {
    state.groups = map(state.groups, group => {
      if (group.id === payload.id) {
        return payload;
      }
      return group;
    });
  },
  [types.GROUP_LIST_RESET]: state => {
    state.groups = [];
    state.userMeta = {
      page: 1,
      hasNextPage: true
    };
  },
  [types.GROUP_LIST_PAGINATE]: (state, payload) => {
    const { page } = state.userMeta;
    state.groups = [...state.groups, ...payload.data];
    state.userMeta = {
      page: page + 1,
      hasNextPage: payload.meta.hasNextPage
    };
  },
  [types.USER_SET_TAB]: (state, payload) => {
    state.userTab = payload;
  },
  [types.SET_ACTIVE_USER]: (state, user) => {
    state.activeUser = user;
  },
  [types.HISTORY_ACTIVE_USER]: (state, user) => {
    state.historyPickedUser = user;
  },
  [types.SET_SETTINGS_LOADER]: (state, payload) => {
    state.settingsLoader = payload;
  },
  [types.FETCH_LOCATION_PAGINATE]: (state, payload) => {
    const { page } = state.locationMeta;
    state.locations = uniqBy([...state.locations, ...payload.data], "id");
    state.locations.map(location => {
      Object.assign(location, {
        label: location.name,
        value: location.id
      });
    });
    state.locationMeta = {
      page: page + 1,
      hasNextPage: payload.meta.hasNextPage
    };
  },
  [types.LOCATION_LIST_RESET]: state => {
    state.locations = [];
    state.locationMeta = {
      page: 1,
      hasNextPage: true
    };
  },
  [types.FETCH_CATEGORY_PAGINATE]: (state, payload) => {
    const { page } = state.categoryMeta;
    state.categories = uniqBy([...state.categories, ...payload.data], "id");
    state.categories.map(category => {
      Object.assign(category, {
        label: category.name,
        value: category.id
      });
    });
    state.categoryMeta = {
      page: page + 1,
      hasNextPage: payload.meta.hasNextPage
    };
  },
  [types.CATEGORY_LIST_RESET]: state => {
    state.categories = [];
    state.categoryMeta = {
      page: 1,
      hasNextPage: true
    };
  },
  [types.EVENT_LIST_PAGINATE]: (state, payload) => {
    const { page } = state.eventMeta;
    state.events = uniqBy([...state.events, ...payload.data], "id");
    state.eventMeta.hasNextPage = payload.meta.hasNextPage;
    state.eventMeta.page = page + 1;
  },
  [types.EVENT_LIST_RESET]: state => {
    state.events = [];
    state.eventMeta = {
      page: 1,
      hasNextPage: true,
      size: 40
    };
  },
  [types.FETCH_SCHEDULE_PAGINATE]: (state, payload) => {
    const { page } = state.scheduleMeta;
    state.schedules = uniqBy([...state.schedules, ...payload.data], "id");
    state.schedules.map(schedule => {
      Object.assign(schedule, {
        label: schedule.name,
        value: schedule.id
      });
    });
    state.scheduleMeta = {
      page: page + 1,
      hasNextPage: payload.meta.hasNextPage
    };
  },
  [types.SET_SCHEDULE_NEW]: (state, payload) => {
    state.newSchedules = payload || [];

    if (state.newSchedules.length < 1) {
      Cookies.remove("newSchedules");
    } else {
      const expires = new Date();
      expires.setTime(expires.getTime() + 10 * 60 * 1000); // New items lasts 10mins
      Cookies.set("newSchedules", JSON.stringify(state.newSchedules), {
        expires
      });
    }
  },
  [types.SCHEDULE_LIST_RESET]: state => {
    state.schedules = [];
    state.scheduleMeta = {
      page: 1,
      hasNextPage: true
    };
  },
  [types.SET_PAYMENT_METHOD]: (state, payload) => {
    state.setPayMethod = payload;
  },
  [types.SET_TOTAL_BOOKINGS_TODAY]: (state, payload) => {
    state.totalBookingsToday = payload;
  }
};
